import { HelpCircleIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { Accordion } from 'components/Accordion/Accordion';
import { Toggle } from 'components/FormComponents';

const integrationHelpTooltipRootClass =
  'max-w-[min(320px,calc(100vw-24px))] [&_.tooltip-inner]:max-w-[min(320px,calc(100vw-24px))] [&_.tooltip-inner]:px-[14px] [&_.tooltip-inner]:py-3 [&_.tooltip-inner]:text-left [&_.tooltip-inner]:text-black [&_.tooltip-inner]:bg-white [&_.tooltip-inner]:border [&_.tooltip-inner]:border-border-primary [&_.tooltip-inner]:rounded-[10px] [&_.tooltip-inner]:shadow-[0_2px_8px_rgba(0,0,0,0.12)] [&_.tooltip-inner]:!opacity-100 [&_.tooltip-inner]:text-[1.4rem] [&_.tooltip-inner]:leading-[1.45] [&_.tooltip-inner]:font-normal [&_.tooltip-arrow::before]:!border-b-white';

export const IntegrationCard = ({
  logo,
  title,
  subtitle,
  helpTooltip,
  children,
  enabled,
  onToggle,
}) => {
  const integrationHeader = (
    <span className="text-neutral-7 text-xl font-medium">Manage details</span>
  );
  return (
    <div className="bg-neutral-1 rounded-3xl border border-border-primary flex flex-col gap-6">
      <div className="px-6 pt-6">
        <div className="flex min-h-48 items-center justify-center border border-border-primary rounded-3xl bg-neutral-2">
          <img className="max-h-32 max-w-64 object-contain object-center" src={logo} alt="" />
        </div>
      </div>
      <div className={`flex flex-col gap-6 ${children ? '' : 'pb-6'}`}>
        <div className="flex flex-wrap items-start justify-between gap-4 px-6">
          <div className="flex min-w-0 flex-1 items-center gap-4">
            <span className="text-primary-4 text-2xl font-medium">{title}</span>
            {helpTooltip ? (
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 200, hide: 400 }}
                overlay={
                  <Tooltip
                    id={`integration-help-${String(title).replace(/\s+/g, '-')}`}
                    className={integrationHelpTooltipRootClass}>
                    <span className="block">{helpTooltip}</span>
                  </Tooltip>
                }>
                <span className="inline-flex cursor-default shrink-0" role="presentation">
                  <HugeiconsIcon
                    icon={HelpCircleIcon}
                    size="20"
                    strokeWidth="1.5"
                    className="text-text-tertiary"
                  />
                </span>
              </OverlayTrigger>
            ) : null}
          </div>
          {onToggle && <Toggle inputProps={{ checked: enabled, onChange: onToggle }} />}
        </div>
        {subtitle != null && subtitle !== false && (
          <div className="px-6 text-neutral-6 text-xl font-light leading-snug [&_a]:font-medium">
            {subtitle}
          </div>
        )}
        {children && (
          <div className="px-6 border-t border-neutral-4 py-3">
            <Accordion header={integrationHeader}>
              <div className="w-full">{children}</div>
            </Accordion>
          </div>
        )}
      </div>
    </div>
  );
};
